import { lazy, Suspense, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { MapViewProps } from './MapView';

const MapView = lazy(() => import('./MapView'));

/**
 * Mapa carregat a part i només quan entra a la vista (IntersectionObserver): obrir una fitxa amb
 * dades mòbils no baixa MapLibre si el visitant no arriba fins al mapa (§10.4, pes).
 */
export function LazyMap(props: MapViewProps & { className?: string }) {
  const { t } = useTranslation('common');
  const texts = { gestureMobile: t('map.gestureMobile'), gestureDesktop: t('map.gestureDesktop') };
  const holder = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = holder.current;
    if (!el) return;
    if (!('IntersectionObserver' in window)) { setVisible(true); return; }
    const io = new IntersectionObserver((entries) => { if (entries.some((e) => e.isIntersecting)) { setVisible(true); io.disconnect(); } }, { rootMargin: '200px' });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <div ref={holder} className={`map-holder${props.className ? ` ${props.className}` : ''}`}>
      {visible && <Suspense fallback={null}><MapView texts={texts} {...props} /></Suspense>}
    </div>
  );
}
